import { generateQueryString } from '../../helpers/articleHelpers';
import { getAPIDomain, getStaticHostname } from '../../helpers/configHelpers';
import { setCookie } from '../../helpers/cookieHelpers';
import { logger } from '../../helpers/logger';
import { setStatusCode } from './status';

const PARTNER_COOKIE_NAME = 'partner';
const PARTNER_COOKIE_EXPIRY_DAYS = 1;

export const FETCH_PAGE_START = 'FETCH_PAGE_START';
export const FETCH_PAGE_END = 'FETCH_PAGE_END';
export const FETCH_PAGE_ERROR = 'FETCH_PAGE_ERROR';

export const PREVIOUS_ROUTE = 'PREVIOUS_ROUTE';

export const fetchPage =
  (url, partnerCookie, hostname, path, isCustomDomain) => async (dispatch) => {
    const contentAPIDomain = getAPIDomain();
    const parsedUrl = new URL(url, contentAPIDomain);

    const urlPath = parsedUrl.pathname;
    const partner = parsedUrl.searchParams.get('partner');

    const staticHostname = getStaticHostname();

    /* istanbul ignore next -- @preserve */
    const staticSearchParams = {
      hostname: staticHostname || hostname,
      partner: partner || partnerCookie || null,
    };

    const queryString = generateQueryString(staticSearchParams);

    if (urlPath.includes('.js')) {
      // stops service worker when requesting files firing pageData request
      return;
    }

    const normalizedSsrPath = path && !path.startsWith('/') ? `/${path}` : '';

    const pathSlug =
      isCustomDomain && !urlPath.startsWith(normalizedSsrPath)
        ? `${normalizedSsrPath}${urlPath}`
        : urlPath;

    const pageURL = `${contentAPIDomain}${pathSlug}${queryString}`;

    try {
      dispatch({ type: FETCH_PAGE_START });

      const validStatuses = [404];

      const headers = {
        Authorization: 'Basic U0pQOlBhcnRuZXI=',
        'Content-Type': 'application/json',
      };

      logger.debug(`Fetching page data from URL: ${pageURL}`);

      const res = await fetch(pageURL, {
        method: 'GET',
        headers,
      });

      const pageData = await res.json();

      logger.debug(`Received page data for URL: ${pageURL}`, pageData);

      await dispatch(setStatusCode(res.status));

      if (!res.ok && !validStatuses.includes(res.status)) {
        logger.debug(`Failed to fetch page data. Status: ${res.status}. URL: ${pageURL}.`);
        throw new Error(`Failed to fetch page data. Status: ${res.status}. URL: ${pageURL}.`);
      }

      if (typeof window !== `undefined` && pageData.responseCode && pageData.url) {
        logger.debug(`Executing client-side redirect to URL: ${pageData.url}.`);
        window.location.replace(pageData.url);
      }

      /* istanbul ignore next -- @preserve */
      if (pageData) {
        logger.debug(`Dispatching page data for URL: ${pageURL}.`);

        dispatch({
          type: FETCH_PAGE_END,
          payload: pageData,
        });

        const partnerFromResponse = pageData?.context?.content?.partner;
        if (typeof window !== 'undefined' && partnerFromResponse) {
          setCookie(PARTNER_COOKIE_NAME, partnerFromResponse, PARTNER_COOKIE_EXPIRY_DAYS);
        }
      }
    } catch (error) {
      dispatch({ type: FETCH_PAGE_ERROR });

      if (typeof window !== `undefined` && window.location) {
        logger.error(`Error fetching page data for URL: ${pageURL}`, error);
        window.location.replace('/500');
      } else {
        throw error;
      }
    }
  };

export const setPreviousRoute = (prevRoute) => async (dispatch) => {
  if (prevRoute) {
    // set previousPath in sessionStorage
    if (typeof window !== `undefined`) {
      sessionStorage.setItem('previousRoute', prevRoute);
    }

    dispatch({
      type: PREVIOUS_ROUTE,
      payload: prevRoute,
    });
  }
};
